import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        idFilial: 0,
        member: "",
        therapist: "",
        idEstadoVigencia: 0, //91,
        idEstado: 2,
    },
    listFilial: [],
    listEstadoVigencia: [],
    listEstado: [],
    results: [],
}

export const therapyPlanSearchSlice = createSlice({
    name: "therapyPlanSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResult: (state, action) => {
            state.results = action.payload;
        },
        setListFilial: (state, action) => {
            state.listFilial = action.payload;
        },
        setListEstadoVigencia: (state, action) => {
            state.listEstadoVigencia = action.payload;
        },
        setListEstado: (state, action) => {
            state.listEstado = action.payload;
        },
    },
});

export const { setValue, setResults
    , setListFilial, setListEstadoVigencia, setListEstado } = therapyPlanSearchSlice.actions;
export default therapyPlanSearchSlice.reducer;
